/* Pulse Tech – tags Judge.me's new-widget star icons so pulse-reviews.css can draw them as SVG.
   The icon <span class="jm-star-rating__font-icon"> contains a private-use glyph:
   U+E000 = full star, U+E001 = empty star, U+E002 = half star. */
(function () {
  var MAP = { '\ue000': 'full', '\ue001': 'empty', '\ue002': 'half' };
  var SEL = '.jm-star-rating__font-icon';

  function tag(el) {
    var ch = (el.textContent || '').trim().charAt(0);
    var v = MAP[ch] || 'full';
    if (el.getAttribute('data-pulse-star') !== v) el.setAttribute('data-pulse-star', v);
  }
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SEL)) tag(root);
    var list = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < list.length; i++) tag(list[i]);
  }

  function start() {
    scan(document.documentElement);
    if (!('MutationObserver' in window)) return;
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData' && m.target.parentElement) tag(m.target.parentElement.closest(SEL) || m.target.parentElement);
        for (var j = 0; j < m.addedNodes.length; j++) scan(m.addedNodes[j]);
      }
      if (!pending) { pending = true; requestAnimationFrame(function () { pending = false; scan(document.documentElement); }); }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
